import {get} from 'lodash-es';

const storeLocation = 'v2.pages.yourContent';

export const yourContentPageState = (state, content) => {
  return get(state, `${storeLocation}.${content}`, []);
};
